import React from 'react';
import Grid from '@mui/material/Grid';
import TextInput from 'components/form/TextInput';
import CheckboxGroup from 'components/form/CheckboxGroup';
import RadioGroup from 'components/form/RadioGroup';
import DatePicker from 'components/form/DatePicker';
import ColorPicker from 'components/form/ColorPicker';
import Select from 'components/form/Select';
import DropZone from 'components/form/Dropzone';
import PhoneInput from 'components/form/PhoneInput';
import DateInput from 'components/form/DatePicker';
import Dropzone from 'components/form/Dropzone';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Button from 'components/Button';
import { EmailIcon } from 'components/icons';
import NameField from './NameField';
import Box from '@mui/material/Box';

export const buildOptions = (fieldOptions) => {
  if (!fieldOptions) return [];
  if (Array.isArray(fieldOptions)) return fieldOptions;

  const options = fieldOptions.split(';');
  return options.map((option) => {
    const [label, value] = option.split('|');
    return { value, label };
  });
};

const FormField = ({ field, ...rest }) => {
  const {
    fieldName,
    isRequired,
    fieldType,
    fieldLabel,
    fieldHint,
    fieldOptions,
  } = field;
  const options = field.options ?? buildOptions(fieldOptions);

  let Component;
  let props = {
    fullWidth: true,
    label: fieldLabel,
    name: fieldName,
    required: isRequired,
    hint: fieldHint,
    margin: 'none',
  };
  switch (fieldType) {
    case 'text':
      Component = TextInput;
      break;
    case 'textarea':
      Component = TextInput;
      props.multiline = true;
      props.rows = 3;
      break;
    case 'phone':
      Component = PhoneInput;
      break;
    case 'date':
      Component = DatePicker;
      break;
    case 'email':
      Component = TextInput;
      props.startAdornment = <EmailIcon />;
      break;
    case 'select':
      Component = Select;
      props.menuPosition = 'fixed';
      props.options = options;
      props.transformValue = true;
      props.menuPortalTarget = document.body;
      break;
    case 'color':
      Component = ColorPicker;
      break;
    case 'url':
      Component = TextInput;
      break;
    case 'file':
      Component = Dropzone;
      props.accept = '*';
      break;
    case 'csv':
      Component = Dropzone;
      props.accept = {
        'text/csv': ['.csv'],
      };
      break;
    case 'logo':
      Component = Dropzone;
      break;
    case 'checkbox':
      Component = CheckboxGroup;
      props.options = options;
      props.row = true;
      break;
    case 'radio':
      Component = RadioGroup;
      props.options = options;
      props.row = true;
      break;
    case 'name':
      Component = NameField;
      break;
    case 'divider':
      props = {};
      Component = Divider;
      break;
    case 'header':
      props = {
        variant: 'h4',
        fontWeight: 600,
      };
      Component = Typography;
      props.children = fieldLabel;
      break;
    case 'button':
      props = {
        component: 'a',
        target: '_blank',
        href: field.fieldAction,
      };
      Component = Button;
      props.children = fieldLabel;
      break;
    case 'image':
      props = {};
      Component = (props) => (
        <Box {...props}>
          <img
            src={field.imgUrl}
            style={{
              width: '100%',
              height: 'auto',
            }}
          />
        </Box>
      );
      break;
    default:
      Component = Typography;
      props.children = 'Not implemented';
      break;
  }

  return <Component {...props} {...rest} />;
};

export default FormField;
